import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";
import { map } from "rxjs/operators";

interface DronePointPhotoModalComponentState {
    photoUrls: string[];
    currentIndex: number;
    arePhotoUrlsProcessing: Record<string, boolean>;
}

export interface PhotoModalData {
    photoUrls: string[];
    currentPhotoIndex: number;
}

@Component({
    templateUrl: "./drone-point-photo-modal.component.html",
    styleUrls: ["./drone-point-photo-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class DronePointPhotoModalComponent {
    protected readonly photoUrls$ = this.localStore.selectByKey("photoUrls");
    protected readonly currentIndex$ = this.localStore.selectByKey("currentIndex");
    protected readonly arePhotoUrlsProcessing$ = this.localStore
        .selectByKey("arePhotoUrlsProcessing")
        .pipe(map((arePhotoUrlsProcessing) => Object.values(arePhotoUrlsProcessing).every((isProcessing) => isProcessing)));

    constructor(
        private readonly localStore: LocalComponentStore<DronePointPhotoModalComponentState>,
        @Inject(MAT_DIALOG_DATA) public readonly data: PhotoModalData
    ) {
        this.localStore.setState({
            photoUrls: this.data.photoUrls,
            currentIndex: this.data.currentPhotoIndex,
            arePhotoUrlsProcessing: this.data.photoUrls.reduce<Record<string, boolean>>(
                (result, photoUrl) => ({ ...result, [photoUrl]: true }),
                {}
            ),
        });
    }

    protected previousPhoto(): void {
        this.localStore.patchState(({ currentIndex, photoUrls }) => {
            const newCurrentIndex = currentIndex <= 0 ? photoUrls.length - 1 : currentIndex - 1;

            return { currentIndex: newCurrentIndex };
        });
    }

    protected nextPhoto(): void {
        this.localStore.patchState(({ currentIndex, photoUrls }) => {
            const newCurrentIndex = currentIndex >= photoUrls.length - 1 ? 0 : currentIndex + 1;

            return { currentIndex: newCurrentIndex };
        });
    }

    protected setPhotoUrlProcessing(isProcessing: boolean, photoUrl: string): void {
        this.localStore.patchState(({ arePhotoUrlsProcessing }) => ({
            arePhotoUrlsProcessing: { ...arePhotoUrlsProcessing, [photoUrl]: isProcessing },
        }));
    }
}
